import React from "react";
import { ButtonGroup } from "react-bootstrap";
import TrackedButton, { TrackedButtonWithTooltip } from "../TrackedButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
type Option = {
  text: string;
  icon: IconProp;
  apiName: string;
  disabled?: boolean;
  tooltip?: () => JSX.Element;
};
type Props = {
  selected: string;
  onSelect: (option: Option) => any;
  options: Option[];
  btnClassName?: string;
  spanClassName?: string;
};

export const MultiButton: React.SFC<Props> = ({
  options,
  selected,
  onSelect,
  btnClassName,
  spanClassName,
}) => {
  return (
    <ButtonGroup>
      <div className="btn-group">
        {options.map((option, i) => {
          const props = {
            disabled: option.disabled || false,
            key: i,
            action: "multiButtonClick",
            label: option.text,
            className: `btn--multi-${(option.apiName || "").replace(
              " ",
              "_"
            )} ${btnClassName || ""} mr-2`,
            color: "primary",
            outline: option.apiName !== selected,
            onClick: () => onSelect(option),
          };
          const children = (
            <>
              {option.icon && <FontAwesomeIcon icon={option.icon} />}
              <span
                style={{ textOverflow: "clip" }}
                className={`text-truncate ${spanClassName}`}
              >
                {option.text}
              </span>
            </>
          );

          const variant = option.apiName === selected ? "primary" : "secondary";
          return option.tooltip ? (
            <TrackedButtonWithTooltip
              id={i.toString()}
              placement="bottom"
              variant={variant}
              renderTooltip={option.tooltip}
              {...props}
            >
              {children}
            </TrackedButtonWithTooltip>
          ) : (
            <TrackedButton variant={variant} {...props}>
              {children}
            </TrackedButton>
          );
        })}
      </div>
    </ButtonGroup>
  );
};

export default MultiButton;
